import * as Api from '../../../api/Api';
import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import { useGetToken } from '../../../Hooks/CustomHooks';
import * as Utilities from '../../../Components/Utils/Utils';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../_metronic/layout/core';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import AgTable from '../../../Components/Table/AgTable';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

export default function DiarioComparativoVentas({ title }) {
    const animatedComponents = makeAnimated();
    const [unidadEconomica, setUnidadEconomica] = useState(Utilities.getListUnidadesEconomicas().list[0]);
    const [inflacion, setInflacion] = useState(false)
    const [sss, setSss] = useState(false)
    const [condition, setCondition] = useState(false)
    const [dateRangeError, setDateRangeError] = useState(false)
    let unidadesEconomicasList = Utilities.getListUnidadesEconomicas();


    const getOptionValue = idDefault => {
        return unidadesEconomicasList.list.filter(obj => obj.value === idDefault)
    }

    const onChangeGraphType = (inputValue) => {
        //setEnableQuery(true); //Everytime the select changes, it enables the useQuery condition for ChartFromServer
        setUnidadEconomica(inputValue);
    }

    const onChangeInflacion = () => {
        setInflacion(!inflacion);
        setCondition(true)
    }

    const onChangeSss = () => {
        setSss(!sss);
        setCondition(true)
    }

    const dRango = new Date();
    const yearRango = dRango.getFullYear();
    const monthRango = dRango.getMonth();

    const [date1Rango, setDate1Rango] = useState(new Date(yearRango, monthRango, 1));
    const [date2Rango, setDate2Rango] = useState(new Date());

    const [dateRange, setDateRange] = useState([date1Rango, date2Rango]);
    const [startDate, endDate] = dateRange;

    let dateFormatedDiaMesInicio = null;
    if (dateRange[0])
        dateFormatedDiaMesInicio = ("0" + (dateRange[0].getDate())).slice(-2) + "/" + ("0" + (dateRange[0].getMonth() + 1)).slice(-2);

    let dateFormatedDiaMesFin = null;
    if (dateRange[1])
        dateFormatedDiaMesFin = ("0" + (dateRange[1].getDate())).slice(-2) + "/" + ("0" + (dateRange[1].getMonth() + 1)).slice(-2);


    const d = new Date();
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();

    const [año1, setAño1] = useState(new Date(year, month, day));
    let dateFormated1 = año1.getFullYear();

    const [año2, setAño2] = useState(new Date(Utilities.getAnioComparativo(), month, day));
    let dateFormated2 = año2.getFullYear();

    registerLocale('es', es);

    const [value, onChangeValue] = useState([new Date(yearRango, monthRango, 1), new Date()]);
    const [ventasAnio1, setVentasAnio1] = useState(null)
    const [ventasAnio2, setVentasAnio2] = useState(null)
    const [areaAnio1, setAreaAnio1] = useState(null)
    const [areaAnio2, setAreaAnio2] = useState(null)
    const [ventaM2Anio1, setVentaM2Anio1] = useState(null)
    const [ventaM2Anio2, setVentaM2Anio2] = useState(null)

    const headerTable = [
        {
            headerName: 'CeBe',
            field: 'categoria',
            rowDrag: true,
            aggFunc: () => ('Totales')
            // headerClassName: 'text-gray-800 mb-1',
            // className: 'min-w-125px column-left'
        },
        {
            headerName: 'Venta ' + año1.getFullYear(),
            field: 'ventasAnio1',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio1),
            cellRenderer: (params) => (<>{Utilities.comillasFix(params.value, true)}</>)
        },
        {
            headerName: 'Venta ' + año2.getFullYear(),
            field: 'ventasAnio2',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setVentasAnio2),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Cumpli Vta',
            field: 'cumplimientoVntas',
            type: 'rightAligned',
            aggFunc: () => (ventasAnio1 && ventasAnio2) ? ((ventasAnio1 / ventasAnio2) * 100).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.value)}</>
            )
        },
        {
            headerName: 'Área ' + año1.getFullYear(),
            field: 'superfVtaAnio1',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setAreaAnio1),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerName: 'Área ' + año2.getFullYear(),
            field: 'superfVtaAnio2',
            type: 'rightAligned',
            aggFunc: params => Utilities.sumColumns(params, setAreaAnio2),
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Vta/m<sup>2</sup> {año1.getFullYear()}</span>),
            field: 'vtaM2Anio1',
            type: 'rightAligned',
            aggFunc: () => {
                setVentaM2Anio1((ventasAnio1 && areaAnio1) ? ((ventasAnio1 / areaAnio1)).toFixed(2) : null)
                return ventaM2Anio1
            },
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Vta/m<sup>2</sup> {año2.getFullYear()}</span>),
            field: 'vtaM2Anio2',
            type: 'rightAligned',
            aggFunc: () => {
                setVentaM2Anio2((ventasAnio2 && areaAnio2) ? ((ventasAnio2 / areaAnio2)).toFixed(2) : null)
                return ventaM2Anio2
            },
            cellRenderer: (props) => (
                <>{Utilities.comillasFix(props.value, true)}</>
            )
        },
        {
            headerComponent: () => (<span>Cumpli Vta/m<sup>2</sup> {año2.getFullYear()}</span>),
            field: 'cumplimientoVntasM2',
            type: 'rightAligned',
            aggFunc: () => (ventaM2Anio1 && ventaM2Anio2) ? ((ventaM2Anio1 / ventaM2Anio2) * 100).toFixed(2) : null,
            cellRenderer: (props) => (
                <>{Utilities.setClassDiferenceTable(props.value)}</>
            )
        }
    ]

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.DIARIO_COMPARATIVO]} >
                <PageTitle>{title} </PageTitle>

                <div className="card my-5">
                    <div className="card-header border-0 pt-6 row g-3 flex-wrap d-flex flex-row">
                        
                        <div className="col-12 col-sm-6 col-md-3">
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Mall:</div>
                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValue(unidadesEconomicasList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={unidadesEconomicasList.list}
                                onChange={(onChangeGraphType)}
                            />
                        </div>
                        <div className='col-12 col-sm-6 col-md-2'>
                            <div className='p-2 form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    name='inflacion'
                                    defaultChecked={false}
                                    onChange={(onChangeInflacion)}
                                />
                                <label className='form-check-label'>Inflación</label>
                            </div>
                            <div className='p-2 form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    name='sss'
                                    defaultChecked={false}
                                    onChange={(onChangeSss)}
                                />
                                <label className='form-check-label'>SSS</label>
                            </div>
                        </div>
                        <div className='col-12 col-sm-6 col-md-5'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Rango de Fecha:</div>
                            <DateRangePicker
                                onChange={(dateRange) => {
                                    onChangeValue(dateRange)
                                    if (dateRange) {
                                        if (dateRange[0].getFullYear() === dateRange[1].getFullYear()) {
                                            setAño1(dateRange[0])
                                            dateRange && setDateRange(dateRange);
                                            setDateRangeError(false)
                                        } else {
                                            setDateRangeError(true)
                                        }
                                    }
                                }}
                                value={value}
                                format="dd/MM/y"
                                className="form-control form-control-transparent pe-5 fit-content-width"
                                // minDate={new Date(dateFormated1, 0, 1)}
                                locale="es"
                            />
                            <>{dateRangeError && <span className="text-danger">El rango de fechas debe estar dentro del mismo año</span>}</>
                        </div>
                        <div className='col-12 col-sm-6 col-md-2'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Año Comparativo:</div>
                            <DatePicker
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={año2}
                                onChange={(dateX) => dateX && setAño2(dateX)}
                                dateFormat="yyyy"
                                showYearPicker
                                minDate={Utilities.add_years(new Date(), -6)}
                                maxDate={new Date()}
                            />
                        </div>
                        
                    </div>

                    <div className="card-body tab-content pt-0">
                        <AgTable
                            idContent={"ComparativoDiarioVentas " + unidadEconomica.value + " " + inflacion + " " + sss + " " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + " " + dateFormated1 + " " + dateFormated2}
                            apiService={Api.DiarioComparativoVentas}
                            setAuxData={null}
                            header={headerTable}
                            titleExcel={"ComparativoDiarioVentas - " + unidadEconomica.value + " - Inflacion: " + inflacion + " " + (dateRange[0] != null ? Utilities.formaterDate(dateRange[0]) : "") + " / " + (dateRange[1] != null ? Utilities.formaterDate(dateRange[1]) : "") + " " + dateFormated1 + " " + dateFormated2}
                            conditions={(dateRange[0] != null && dateRange[1] != null) || condition}
                            paginationPageSize={15}
                            updateCondition={setCondition}
                            sumColumns={true}
                            useFlex={false}
                            args={{
                                unidadEconomicaId: unidadEconomica.value,
                                inflacion: inflacion,
                                diaMesInicio: dateRange[0] && dateFormatedDiaMesInicio,
                                diaMesFin: dateRange[1] && dateFormatedDiaMesFin,
                                anio1: dateFormated1,
                                anio2: dateFormated2,
                                token: useGetToken(),
                                sss: sss
                            }} // * para filters
                        />
                    </div>
                </div>
            </PermissionsGate>
        </>
    )
}